module.exports = __webpack_public_path__ + "img/aliyun.512e7343.png";